import { isIosUa, isKcloudWebSupportBrowser, isDesktopUa } from '@/utils/user_agents'
import { loginRouteFor } from '@/router/route_utils'
import { sendRouteToHubSpot } from "@/utils/hubspot_utils"
import { useWebViewModeStore } from '@/stores/webViewMode'
import { sendConstructionCreateClosed } from '@/utils/webViewBridge'
import { type Router } from 'vue-router'
import { type RouteLocationNormalized } from 'vue-router'
import { useHeaderStore } from '@/stores/header'
import { useTalkStore } from '@/stores/talk'
import { useBackRouteStore } from '@/stores/backRoute'
import { useTrackingsStore } from '@/stores/trackings'
import { usePendingRoute } from '@/stores/pendingRoute'
import { useLoginStore } from '@/stores/login'

// ログインチェックAPIの引数を返す
const checkLoginAccountApiArgs = (to: RouteLocationNormalized, noErrorDialog: boolean) => {
  if(to.meta && to.meta.apiOptions){
    return { __apiOptions: to.meta.apiOptions }
  }
  return {
    __apiOptions: {
      noErrorDialog: noErrorDialog,
      noDisplayLoading: true
    }
  }
}

export const initRouterEventHandler = (router: Router) => {
  router.beforeEach(async (to, from, next) => {
    const { currentAccount, checkLoginAccount } = useLoginStore()
    console.info('to',to)
    console.info('from',from)
    console.info('meta',to.meta)
    if(to.meta && !to.meta.omitPlatformCheck){
      // WebViewモード判定（初回のみクエリから初期化、以降はsessionStorageから復元）
      const webViewModeStore = useWebViewModeStore()
      if (to.query.webview === '1') {
        webViewModeStore.initFromQuery(to.query)
      }
      // WebViewモードでなければ通常のプラットフォームチェック
      if (!webViewModeStore.isWebViewMode) {
        // 環境のチェック
        console.info('meta2',to.meta)
        if(isIosUa()){
          // iOS の場合にアプリリンクへ遷移
          const iosApplinkUrl = import.meta.env.VITE_APP_IOS_APPLINK_URL;
          window.location = iosApplinkUrl as string&Location;
          next(false)
          return;
        }
        const noSupportRoute = { name: 'NoSupportBrowser' };
        if(!isDesktopUa()){
          // mobile OSの場合
          next(noSupportRoute);
          return;
        }
        if (!isKcloudWebSupportBrowser()) {
          // 推奨ブラウザ以外
          console.info('meta2',to.meta)
          next(noSupportRoute);
          return;
        }
      } else {
        // WebViewモードでは工事作成ルート以外への遷移を禁止
        const isAllowedRoute = to.matched.some(r => r.name === 'CreateConstruction')
        if (!isAllowedRoute) {
          sendConstructionCreateClosed('WebViewモードで許可外ルートへ遷移しようとした', { toFullPath: to.fullPath, fromFullPath: from.fullPath })
          next(false)
          return
        }
      }
    }
    if(to.meta && to.meta.isPublic){
      // セッション不要ルートの場合
      next();
      return;
    }
    // セッションが要るルートの場合
    if(currentAccount){
      const pendingRouteStore = usePendingRoute()
      pendingRouteStore.setPendingRoute(to)

      // アカウント情報がある場合は、並列でアカウント情報を更新
      checkLoginAccount(checkLoginAccountApiArgs(to, false));
      next();
      return;
    }
    // アカウント情報がまだない場合、一回取得
    const accountInfo = await checkLoginAccount(checkLoginAccountApiArgs(to, true));
    if(!accountInfo){
      // ログインしていない場合
      const webViewModeStore = useWebViewModeStore()
      if (webViewModeStore.isWebViewMode) {
        // WebViewモードでセッション切れ → Nativeに閉じるイベントを送信
        // （checkLoginAccountはセッション切れだけでなくNetwork Errorでもfalsyを返す点に注意）
        sendConstructionCreateClosed('checkLoginAccountが失敗（セッション切れまたは通信エラー）', { toFullPath: to.fullPath })
        next(false)
        return;
      }
      // ログイン画面へ
      const loginRoute = loginRouteFor(to)
      next(loginRoute);
      return;
    }
    // OK
    next();
  });
  
  router.beforeResolve((to, from, next) => {
    const { updateReturnKcloudPath, clearTalkLinkUrl } = useTalkStore()
    const { updateLeftHeaderButton, clearTitle } = useHeaderStore()
    const { initBackRoute, updateBackRoute } = useBackRouteStore()

    // ヘッダの表示状態（ボタンとタイトル）を設定する
    updateLeftHeaderButton(null)
    initBackRoute()
    if(to.meta){
      if(to.meta.leftHeaderButton){
        // 左上ボタン
        updateLeftHeaderButton(to.meta.leftHeaderButton as "menu" | "back")
      }
      if(to.meta.backRouteFor){
        // 左上「＜」ボタンの遷移先をセットする
        updateBackRoute((to.meta.backRouteFor as Function)(to, from))
      }
      if(to.meta.logoTitle){
        // タイトルをクリアして、ロゴ表示の状態にする
        clearTitle()
      }
      if(to.meta.disableTalkLink){
        // トークのリンク先をクリアする
        clearTalkLinkUrl()
      }
    }
    // クラウドに戻ってくる時のurlを初期化（画面表示後に適宜変更される）
    updateReturnKcloudPath(to.fullPath)
    next();
  
    const trackingsStore = useTrackingsStore()
    trackingsStore.trackRouteView(to)
  
    // HubSpot track
    sendRouteToHubSpot(to.fullPath);

    // 遷移元のルート名をmetaに設定
    to.meta.fromRouteName = from.name
  });
}

